<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item"><router-link to="/mypage/account">アカウント情報</router-link></li>
                <li class="breadcrumb-item">パスワード・メールアドレス変更</li>
            </ol>
        </nav>
        <div class="container">
            <legend>
                パスワード・メールアドレス変更
            </legend>
            <div class="forms">
                <div class="mb-3">
                    <label>メールアドレス</label>
                    <input type="email" class="form-control" v-model="user.email" :disabled="!user.has_password" />
                    <div class="text-muted small">
                        メールアドレス変更時は、承認メールが送信されます。
                    </div>
                    <div class="text-danger" v-if="!user.has_password">
                        連携ログインのみのアカウントはメールアドレスの変更ができません。
                    </div>
                    <div class="text-danger" v-else-if="user.is_google">
                        メールアドレス変更時はGoogle連携ログインは解除されます。
                    </div>
                </div>
                <hr>
                <div class="text-muted small my-4">
                    以下、変更しない場合は空欄のままにしてください。
                </div>
                <div class="form-group">
                    <label>現在のパスワード</label>
                    <input type="password" class="form-control" v-model="user.current_password" placeholder="OAuth認証のみの場合は空欄" />
                    <div class="text-muted small" v-if="!user.has_password">
                        パスワードが無い場合は空欄のままで結構です。
                    </div>
                </div>
                <div class="form-group">
                    <label>新しいパスワード</label>
                    <input type="password" class="form-control" v-model="user.password" placeholder="8文字以上" />
                    <div class="text-muted small">8文字以上のパスワードを設定してください。</div>
                </div>
                <div class="form-group">
                    <label>新しいパスワード（確認）</label>
                    <input type="password" class="form-control" v-model="user.password_confirmation" />
                </div>
                <div class="form-group my-4 text-center">
                    <button type="button" class="btn btn-outline-danger" @click="save()">
                        メールアドレス・パスワード更新
                    </button>
                </div>
            </div>
            <div class="mt-5 text-center">
                <router-link to="/mypage/account">戻る</router-link>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"
            loader="bars"></loading>
    </div>
</template>

<style scoped>
.forms {
    max-width: 640px;
    margin: 1rem auto;
}
.container {
    padding: 0;
}
</style>

<script>
export default {
    data() {
        return {
            user: {
                email: null,
                current_password: null,
                password: null,
                password_confirmation: null,
            },
            isLoading: false,
        }
    },
    methods: {
        load() {
            axios.get("/mypage/user/get").then(res => {
                this.user = res.data;
            }).catch(err => { alert.err(err.response) });
        },
        save() {
            this.isLoading = true;
            axios.post("/mypage/user/save-security", this.user).then(res => {
                alert.msg(res.data);
                this.user.current_password = null;
                this.user.password = null;
                this.user.password_confirmation = null;
                this.isLoading = false;
            }).catch(err => { alert.err(err) });
        }
    },
    mounted() {
        this.load();
    }
}
</script>